import { getSession } from "../api/queries.js";
import { useQuery } from "../api/useQuery.js";
import { buildAccount, useAuth, type AuthAccount } from "./AuthProvider.js";

/**
 * Who to show as signed in.
 *
 * Prefers the API's session, because that is the identity the request was
 * authorized under. MSAL's cached account is the fallback: it is available
 * before the session query lands (and in dev mode, where there is no session
 * to fetch), but its claims come from a token cached in the browser and can be
 * older than the one the API verified -- which is how the same person could be
 * shown one name here and another in the API's own view of the session.
 *
 * The ACTOR, deliberately, not the impersonated user: this is the person
 * holding the keyboard. ImpersonationBanner reports who they are acting as.
 */
export function useSignedInAccount(): AuthAccount | null {
  const { account } = useAuth();
  const session = useQuery(getSession, undefined);
  const actor = session.data?.actor;

  return actor ? buildAccount(actor.displayName, actor.email) : account;
}
